// extracted by mini-css-extract-plugin
export var ButtonSmall = "button-module--Button--small--b7d75";
export var Button = "button-module--Button--38dc1";
export var ButtonLarge = "button-module--Button--large--77a43";
export var ButtonBlock = "button-module--Button--block--95595";
export var ButtonSkeleton = "button-module--Button--skeleton--b5f44";